export enum PriceWsAction {
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
}

export enum PriceWsEvent {
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  PRICE = 'price',
  ERROR = 'error',
}

export interface PriceUpdate {
  ticker: string;
  exchange: string;
  price: number;
  time: string;
}

interface PricePayload extends PriceUpdate {
  event: PriceWsEvent.PRICE;
}

interface ErrorPayload {
  event: PriceWsEvent.ERROR;
  message: string;
}

interface SubscribedPayload {
  event: PriceWsEvent.SUBSCRIBED;
  ticker: string;
}

interface UnsubscribedPayload {
  event: PriceWsEvent.UNSUBSCRIBED;
  ticker: string;
}

export type SocketResponses =
  | PricePayload
  | SubscribedPayload
  | UnsubscribedPayload
  | ErrorPayload;

export type ErrorHandler = (message: string) => void;

export type UpdateHandler = (update: PriceUpdate) => void;

export type TickerPayload = { ticker: string; trading_country: string };
